/*
 *
 * Report actions
 *
 */
import {
  SAVE_REPORT,
  SAVE_REPORT_SELECTION_ERROR,
  SAVE_REPORT_SELECTION_SUCCESS,
  GET_REPORT_PROGRESS_PREVIEW_SUCCESS,
  GET_REPORT_DATA_PREVIEW,
  GET_REPORT_DATA_PREVIEW_SUCCESS,
  CLEAR_REPORT_DATA_PREVIEW,
  GET_REPORT_DATA_PREVIEW_ERROR,
  CLEAR_REPORT_DATA_PREVIEW_ERROR,
  REPORT_DATA_PREVIEW_WAITING_FOR_CALCULATION,
} from './constants'

export const getReportProgressForPreviewSuccess = ({ progress }) => ({
  type: GET_REPORT_PROGRESS_PREVIEW_SUCCESS,
  progress,
})

export const saveReport = ({
  customerCode,
  companyCode,
  oldReportSelection,
  newReportSelection,
}) => ({
  type: SAVE_REPORT,
  customerCode,
  companyCode,
  oldReportSelection,
  newReportSelection,
})

export const saveReportSelectionError = (error) => ({
  type: SAVE_REPORT_SELECTION_ERROR,
  error,
})

export const saveReportSelectionSuccess = ({
  customerCode,
  companyCode,
  reportSelection,
}) => ({
  type: SAVE_REPORT_SELECTION_SUCCESS,
  customerCode,
  companyCode,
  reportSelection,
})

export const getReportDataPreview = ({
  companyCode,
  customerCode,
  reportSelection,
  setLoading = true,
}) => ({
  type: GET_REPORT_DATA_PREVIEW,
  companyCode,
  customerCode,
  reportSelection,
  setLoading,
})

export const getReportDataPreviewSuccess = ({ report, exchangeRates }) => ({
  type: GET_REPORT_DATA_PREVIEW_SUCCESS,
  report,
  exchangeRates,
})

export const clearReportDataPreview = () => ({
  type: CLEAR_REPORT_DATA_PREVIEW,
})

export const clearReportDataPreviewError = () => ({
  type: CLEAR_REPORT_DATA_PREVIEW_ERROR,
})

export const getReportDataPreviewError = (error) => ({
  type: GET_REPORT_DATA_PREVIEW_ERROR,
  error,
})

export const reportDataPreviewWaitingForCalculation = ({ companies }) => ({
  type: REPORT_DATA_PREVIEW_WAITING_FOR_CALCULATION,
  // Companies whose actuals are being calculated, as named by the API.
  companies: companies || [],
})
